import React from 'react';

// styles
import {LabelContentWrapper} from './LabelContent-styles';
import {TextColors, TextDefault} from '../../styles';

// types
type Props = {
  label: string;
  content: string;
};

const TEXT_COLOR = TextColors.secondary;

const LabelContent = ({label, content}: Props) => {
  return (
    <LabelContentWrapper>
      <TextDefault color={TEXT_COLOR}>{label}</TextDefault>
      <TextDefault bold="bold" color={TEXT_COLOR}>
        {content}
      </TextDefault>
    </LabelContentWrapper>
  );
};

export default LabelContent;
